import * as React from 'react';
import styled from 'styled-components';

export type IconTitleProps = {
  icon: React.ReactNode;
  title: string;
  size?: string;
  color?: string;
};

export const IconTitle: React.FunctionComponent<IconTitleProps> = (
  props: IconTitleProps,
) => {
  return (
    <Container>
      {props.icon}
      <h2 className="!text-left ml-2 p-[0.15rem] text-[#951d1d] font-bold">
        {props.title}
      </h2>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.5rem;
  align-items: start;
  justify-content: flex-start;

  .MuiSvgIcon-root {
    font-size: 2rem !important;
    color: #951d1d;
  }
`;
